const style = (theme) => {
  const iconButtonHeight = 35
  const transition = `all 1s ${theme.easings['power4.out']}`

  const output = {
    root: {
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: theme.zindex.header,
      transition: `all 0.3s ${theme.easings['power4.out']}`,
      pointerEvents: 'none',
      '& $icon': {
        transition,
        background: 'transparent',
        '& svg': {
          transition,
          fill: theme.colors[1],
        },
      },
    },
    background: {
      background: theme.getRgba(theme.colors[2], 0.4),
      '& $logo': {
        '& svg': {
          fill: `${theme.colors[1]} !important`,
        },
      },
      '& a': {
        color: `${theme.colors[1]} !important`,
      },
    },
    minimize: {
      background: 'transparent',
      '& $logo': {
        opacity: 0,
      },
      '& $headerNav': {
        opacity: 0,
      },
    },
    container: {
      margin: '0 auto',
    },
    wrapper: {
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0 0 0 4vw',
      transition,
    },
    logo: {
      display: 'inline-block',
      pointerEvents: 'all',
      transition: `all 0.3s ${theme.easings['power4.out']}`,
      '& svg': {
        transition,
        fill: props => (props.headerInverse ? theme.colors[0] : theme.colors[1]),
      },
    },
    nav: {
      display: 'flex',
      alignItems: 'center',
      pointerEvents: 'all',
      height: '100%',
    },
    headerNav: {
      display: 'flex',
      transition: `all 0.3s ${theme.easings['power4.out']}`,
      '& > *': {
        marginRight: '10vw',
        fontSize: 12,
        color: theme.colors[1],
        textTransform: 'uppercase',
      },
      '& a': {
        color: props => (props.headerInverse ? theme.colors[0] : theme.colors[1]),
      },
    },
    burgerButton: {
      width: theme.header.burger.wrap,
      height: theme.header.burger.wrap,
      background: theme.colors[2],
      cursor: 'pointer',
      textTransform: 'uppercase',
      letterSpacing: 1,
      fontSize: 14,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    icon: {
      borderRadius: 10,
      width: iconButtonHeight,
      height: iconButtonHeight,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '& svg': {
        width: 18,
        height: 18,
      },
    },
    hide: {
      opacity: 0,
      pointerEvents: 'none',
    },
  }

  output[theme.mediaInverse.md] = {
    headerNav: {
      '& > *': {
        marginRight: '6vw',
      },
    },
  }

  output[theme.mediaInverse.sm] = {
    headerNav: {
      display: 'none',
    },
  }

  return output
}

export default style
